/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAktsFromIdRequest
 */
export interface GetAktsFromIdRequest {
    /**
     * 
     * @type {number}
     * @memberof GetAktsFromIdRequest
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAktsFromIdRequest
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAktsFromIdRequest
     */
    type: number;
    /**
     * 
     * @type {string}
     * @memberof GetAktsFromIdRequest
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAktsFromIdRequest
     */
    showFuture?: boolean;
}

export function GetAktsFromIdRequestFromJSON(json: any): GetAktsFromIdRequest {
    return GetAktsFromIdRequestFromJSONTyped(json, false);
}

export function GetAktsFromIdRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAktsFromIdRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'type': json['type'],
        'id': json['id'],
        'showFuture': !exists(json, 'ShowFuture') ? undefined : json['ShowFuture'],
    };
}

export function GetAktsFromIdRequestToJSON(value?: GetAktsFromIdRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'limit': value.limit,
        'offset': value.offset,
        'type': value.type,
        'id': value.id,
        'ShowFuture': value.showFuture,
    };
}


